import {
  PRO_PRICE_CURRENCY,
  PRO_PRICE_PER_MONTH,
  PRO_REGION_NOTE,
  PRO_TRIAL_DAYS,
} from "~/utils/pricing";
import { ProtectedScreen } from "~/components/ui";
import { UpgradePrompt } from "~/components/composed/UpgradePrompt";
import { AppText, Card, Stack } from "~/components/ui";
import { useSubscription } from "~/hooks/useSubscription";

const features = [
  "Time tracking with billable rates",
  "Clients, projects, tasks, and service automations",
  "Invoices, recurring invoices, reminders, payments, and refunds",
  "Expenses, NZ GST-ready fields, reports, and accountant exports",
  "Dashboard notifications and optional recurring-service client emails",
];

export default function SubscriptionScreen() {
  const subscription = useSubscription();
  return (
    <ProtectedScreen
      title="Subscription"
      subtitle="One flat plan for NZ freelancers and micro-businesses."
    >
      <Stack gap="md">
        <Card gap="sm">
          <AppText size="xs">Current access</AppText>
          <AppText size="lg" weight="bold">
            {subscription.hasPaidAccess
              ? "MintStint Pro"
              : "Subscription expired"}
          </AppText>
          <AppText size="xs">
            {`MintStint Pro is ${PRO_PRICE_PER_MONTH} flat, after a ${PRO_TRIAL_DAYS}-day free trial. Billed in ${PRO_PRICE_CURRENCY}. ${PRO_REGION_NOTE}`}
          </AppText>
        </Card>
        <Card gap="sm">
          <AppText weight="semibold">Everything included</AppText>
          {features.map((feature) => (
            <AppText key={feature} size="xs">
              • {feature}
            </AppText>
          ))}
        </Card>
        {!subscription.hasPaidAccess ? (
          <UpgradePrompt
            title="Reactivate MintStint Pro"
            reason={`Your subscription is inactive. Reactivate for ${PRO_PRICE_PER_MONTH} to edit data and keep automations running. You can still view existing records while expired.`}
          />
        ) : null}
      </Stack>
    </ProtectedScreen>
  );
}
